import React from 'react';
import { Copyright, Info } from 'lucide-react';

const CopyrightSettings = ({
    isCopyrighted = false,
    copyrightText = '',
    onIsCopyrightedChange,
    onCopyrightTextChange,
    disabled = false
}) => {
    const handleToggle = () => {
        if (disabled) return;
        onIsCopyrightedChange && onIsCopyrightedChange(!isCopyrighted);
    };

    return (
        <div className={`p-4 border rounded-lg transition-all ${
            isCopyrighted ? 'border-yellow-500/40 bg-yellow-500/5' : 'border-gray-700 bg-gray-800/30'
        }`}>
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${isCopyrighted ? 'bg-yellow-600/20' : 'bg-gray-700/50'}`}>
                        <Copyright className={`w-5 h-5 ${isCopyrighted ? 'text-yellow-400' : 'text-gray-500'}`} />
                    </div>
                    <div>
                        <h4 className={`font-semibold text-sm ${isCopyrighted ? 'text-yellow-400' : 'text-gray-300'}`}>
                            This content is copyrighted
                        </h4>
                        <p className="text-xs text-gray-500">
                            Shows a copyright notice under the title on the media page
                        </p>
                    </div>
                </div>
                <button
                    type="button"
                    onClick={handleToggle}
                    disabled={disabled}
                    aria-label="Toggle copyright notice"
                    aria-pressed={isCopyrighted}
                    className={`relative w-12 h-6 rounded-full transition-colors flex-shrink-0 ${
                        isCopyrighted ? 'bg-yellow-600' : 'bg-gray-600'
                    } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                >
                    <div className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform ${
                        isCopyrighted ? 'translate-x-6' : 'translate-x-0'
                    }`} />
                </button>
            </div>

            {isCopyrighted && (
                <div className="mt-4 space-y-2 pt-4 border-t border-yellow-500/20">
                    <label className="block text-sm font-medium text-gray-300">Copyright Message *</label>
                    <input
                        type="text"
                        value={copyrightText}
                        onChange={(e) => onCopyrightTextChange && onCopyrightTextChange(e.target.value)}
                        className="w-full py-2 px-3 bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500 transition-colors"
                        placeholder="e.g. © 2026 The Deep Wave. All rights reserved."
                        disabled={disabled}
                        maxLength="500"
                    />
                    <p className="text-xs text-gray-500">{copyrightText.length}/500</p>

                    <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-lg p-3 flex items-start gap-2">
                        <Info className="w-4 h-4 text-yellow-400 mt-0.5 flex-shrink-0" />
                        <p className="text-sm text-yellow-300">
                            This message will be displayed under the title on the media page.
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CopyrightSettings;
